export class TimeFormatter {
  static formatTimeString(hours: number, minutes: number): string {
    return `${this.formatNumber(hours)}:${this.formatNumber(minutes)}`
  }

  static formatNumber(num: number): string {
    return num.toString().padStart(2, '0')
  }

  static parseTimeString(timeString: string): [number, number] {
    const [hours, minutes] = timeString.split(':').map(Number)
    return [hours || 0, minutes || 0]
  }

  static formatTime(date: Date, locale = 'fr-FR'): string {
    return date.toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
  }

  static formatDate(date: Date, locale = 'fr-FR'): string {
    return date.toLocaleDateString(locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  static getRelativeAlarmDay(hours: number, minutes: number): 'today' | 'tomorrow' {
    const now = new Date()
    const currentTotalMinutes = now.getHours() * 60 + now.getMinutes()
    const alarmTotalMinutes = hours * 60 + minutes

    return alarmTotalMinutes < currentTotalMinutes ? 'tomorrow' : 'today'
  }
}
